import "./closestPolyfill";
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global-theme.css";
import "./styles/dxp-layout-theme.css";
import "./index.css";
import App from "./App";
import AEPTracking from "./Helpers/aepTracking";
/* Last: override Spectrum S2 cascade (@layer) + MenuTrigger menu width. */
import "./styles/dxp-spectrum-overrides.css";

if (localStorage.getItem("redirectTo") === "DXPHomePage") {
  localStorage.removeItem("redirectTo");
  window.open(`${window.location.origin}/digitalexperience/`, "_self");
}

AEPTracking.init();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(<App />);
